<template>
  <div class="Avt-Img" :style="`max-height: ${props.size}px`">
    <component
      v-if="isComponent"
      class="Avt-Img__image"
      :is="props.src"
      :style="get_styles"
      aria-label="avatar"
    />
    <template v-else>
      <img
        class="Avt-Img__image"
        aria-label="avatar"
        :src="props.src"
        :width="props.size"
        :height="props.size"
        :alt="props.alt"
        :style="get_styles"
        :class="{ 'Avt-Img__image--is-hidden': loading }"
        :loading="props.lazyLoad ? 'lazy' : 'eager'"
        @load="onLoad"
        @error="onError"
      />
      <SkeletAvatar class="Avt-Img__skelet" v-if="props.lazyLoad && loading" :size="props.size" />
    </template>
  </div>
</template>

<script setup>
  import { defineProps, computed, ref } from "vue";
  import { Props } from "./scripts/props.js";
  
  import SkeletAvatar from "@shared/UI/Skeletons/SkeletAvatar/SkeletAvatar.vue";

  const props = defineProps(Props());

  const loading = ref(true);

  const onLoad = () => {
    loading.value = false;
  };
  const onError = () => {
    loading.value = false;
  };

  const get_styles = computed(() => ({
    maxWidth: `${props.size}px`,
    maxHeight: `${props.size}px`,
    minWidth: `${props.size}px`,
    minHeight: `${props.size}px`,
    borderRadius: props.radius,
    filter: props.blur ? "blur(0.5px)" : undefined,
  }));

  const isComponent = computed(() => typeof props.src === "object");
</script>

<style lang="scss">
  @import "./styles/_style.scss";
</style>
